import FAQSubCategory from "./FAQSubCategory";

export default class FAQCategory {
    public id: number;
    public title : string = '';
    public iconSrc : string = '';
    public anchor: string= '';
    public url: string= '';
    public subCategories : FAQSubCategory[] = [];
} 
